export const ROUTE_HOME = "/";
export const ROUTE_VERIFY = "/verify";
export const ROUTE_FORGOT = "/forgot";

export const ROUTE_LOGIN = "/login";
export const ROUTE_REGISTRATION = "/registration/:device/:type?";
export const ROUTE_REGISTRATION_COMPLETE =
  "/registrationComplete/:device/:type";
export const ROUTE_RESTORE = "/restore/:device";

export const ROUTE_SETTINGS = "/settings/:device/:menuCode?/:type?";
export const ROUTE_SETTINGS_WEB = "/settings/web/:menuCode?/:type?";
export const ROUTE_SETTINGS_APP = "/settings/app/:menuCode?/:type?";

export const ROUTE_LAVKA =
  "/lavka/:supplierCode?/:shopCode?/:kategCode?/:productCode?";
export const ROUTE_TABLE_LAVKA = "/tableLavka/:supplierCode";
export const ROUTE_SHOPS_MAIN = "/shopsMain/:supplierCode";
export const ROUTE_SUPPLIER_LIST = "/supplier_list/:parentSupplierCode";
export const ROUTE_SUPPLIER_INFO = "/supplier_info/:code";
export const ROUTE_MYORDERS = "/myOrders";

export const ROUTE_ADMIN = "/admin";
export const ROUTE_ADMIN_OBJECT = "/admin/obj/:code?";
export const ROUTE_ADMIN_TRADERS = "/admin/traders";
export const ROUTE_ADMIN_CATEGORIES = "/admin/categories";
export const ROUTE_ADMIN_PRODUCTS = "/admin/products";
export const ROUTE_ADMIN_ORDERS = "/admin/orders";
export const ROUTE_ADMIN_CONTRACTS = "/admin/contracts";
export const ROUTE_ADMIN_SHOPS_SUPPLIERS = "/admin/shops_suppliers";
export const ROUTE_ADMIN_CATEGORIES_TYPE_RETAILY =
  "/admin/categories_type_retaily";
export const ROUTE_ADMIN_PRODUCTS_TYPE_RETAILY = "/admin/products_type_retaily";
export const ROUTE_ADMIN_SUPPLIERS_REPORTS_DAY = "/admin/suppliers/reports/day";
export const ROUTE_ADMIN_SUPPLIERS_REPORTS_DINAMICA_PRODAJ =
  "/admin/suppliers/reports/dinamicaProdaj";
export const ROUTE_ADMIN_SUPPLIERS_REPORTS_ORDERS =
  "/admin/suppliers/reports/orders";
export const ROUTE_ADMIN_SUPPLIERS_REPORTS_LOGS =
  "/admin/suppliers/reports/logs";
export const ROUTE_ADMIN_SUPPLIERS_ANALYZE_LOGIN =
  "/admin/suppliers/analyze/:table";
export const ROUTE_ADMIN_SUPPLIERS_ANALYZE_SHOPS =
  "/admin/suppliers/analyze/shops";
export const ROUTE_ADMIN_SUPPLIERS_ANALYZE_POLLS =
  "/admin/suppliers/analyze/polls";
export const ROUTE_ADMIN_DASHBOARD_METRICA = "/admin/dashboard/metrica";
export const ROUTE_ADMIN_DASHBOARD_AVERAGE_CHECK =
  "/admin/dashboard/average_check";
export const ROUTE_ADMIN_PROMO = "/admin/promo/:table?/:type?";
export const ROUTE_ADMIN_PROMO_PUSH_NOTIFY = "/admin/push_notify";

export const ROUTE_ADMIN_SPECIFICATION = "/admin/specification/:table";
export const ROUTE_ADMIN_SUPPLIER_PROFILE = "/admin/supplierProfile";
export const ROUTE_ADMIN_SUPPLIER_TRADERS = "/admin/supplier_traders";
export const ROUTE_ADMIN_DISCOUNT = "/admin/discount";

//admin PARTNERS
export const ROUTE_ADMIN_PARTNER_SUPPLIER = "/admin/partner_suppliers";

export const ROUTE_MOBILE_CATALOG_LIST = "/mobile/catalog/list";
//export const ROUTE_MOBILE_CATALOG_KATEGORIES = '/mobile/catalog/categories/:supplierCode'
export const ROUTE_MOBILE_CATALOG_PRODUCTS =
  "/mobile/catalog/products/:supplierCode/:shopCode?/:kategCode?/:productCode?";
export const ROUTE_MOBILE_TRASH = "/mobile/trash";
export const ROUTE_MOBILE_PROFILE = "/mobile/profile";

export const ROUTE_POLLS = "/polls/:device/:pollCode";

export const ROUTE_TAPLINK = "/taplink";
export const ROUTE_NOTIFY = "/notify";

export const ROUTE_SBER_BENEFICIARY_LIST = "/admin/sberBeneficiaryList";
export const ROUTE_ADMIN_SBER_BENEFICIARY_REGISTRY =
  "/admin/sberBeneficiaryRegistry";
export const ROUTE_ADMIN_SBER_ORDER_PAYMENTS = "/admin/sberOrderPayments";

//SberMomentPay
export const ROUTE_SBER_MOMENT_PAY_BACK = "/sber/back";
export const ROUTE_SBER_MOMENT_PAY = "/sber";

//Bonus
export const ROUTE_BONUS_MYBONUS = "/myBonus";
export const ROUTE_BONUS_CONSTRUCTOR = "/admin/bonusConstructor";

//Discount
export const ROUTE_DISCOUNT_USERS = "/admin/discountUsers";
export const ROUTE_DISCOUNT_CERT = "/admin/discountCert";
export const ROUTE_DISCOUNT_SUPPLIERS = "/admin/discountSuppliers";
export const ROUTE_DISCOUNT_SHOPS = "/admin/discountShops";
export const ROUTE_DISCOUNT_UNIQUE_SHOPS = "/admin/discountUniqueShops";
